import React from "react";
import Alert from "react-bootstrap/Alert";
import { easelColors, easelFontFamily } from "../../helpers/constants";

export interface IAlertProps
  extends Pick<React.ComponentPropsWithRef<typeof Alert>, "variant"> {
  children: React.ReactNode;
}

export const ErrorAlert = (props: IAlertProps) => {
  const { children, variant } = props;

  const style = {
    color: easelColors.easelCoral700,
    backgroundColor: easelColors.easelCoral100,
    borderColor: easelColors.easelCoral100,
    fontFamily: easelFontFamily,
    marginBottom: 0,
    marginTop: "16px",
    textAlign: "left" as "left",
    height: "50px",
    paddingLeft: "12px",
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
  };

  return (
    <Alert variant={variant} style={{ ...style }}>
      {children}
    </Alert>
  );
};
